module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTag) ? _c('div', {
    staticClass: "avue-tags"
  }, [_c('div', {
    staticClass: "avue-tags__box",
    class: {
      'avue-tags__box--close': !_vm.website.isFirstPage
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card",
      "closable": _vm.tagLen !== 1
    },
    on: {
      "tab-click": _vm.openTag,
      "edit": _vm.menuTag
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.tagList), function(item) {
    return _c('el-tab-pane', {
      key: item.code,
      attrs: {
        "label": item.label,
        "name": item.code
      }
    })
  }), 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avue-tags__menu"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("\n\t\t\t\t更多\n\t\t\t\t"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeOthersTags.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭其他")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeAllTags.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭全部")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-b4d1867a!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/pages/framework/tags.vue
// module id = 1157
// module chunks = 99